import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = {
  key: 0,
  class: "login-container"
}

import { ref } from "vue";
import { useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";
import { TelegramClient } from "@/websocket/Client";

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const client = TelegramClient.getInstance();
const router = useRouter();

onMounted(() => {
  client.connect();
});

// onUnmounted(() => {
// 	client.disconnect();
// });

const username = ref(""); // 将 account 改为 username
const password = ref("");
const isLoggedIn = ref(false);

const handleLogin = async () => {
  console.log("开始登录...");
  try {
    const result = await client.login(username.value, password.value);
    console.log("登录结果:", result);
    if (result.success && result.data) {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("username", username.value);
      localStorage.setItem("session", result.data.session); // 保存session
      isLoggedIn.value = true;
      router.push("/chat");
    }
  } catch (error) {
    console.error("登录失败:", error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_proto_command_test = _resolveComponent("proto-command-test")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoggedIn.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_card, {
            title: "用户登录",
            class: "login-box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, {
                direction: "vertical",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: username.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                    placeholder: "用户名"
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_input_password, {
                    value: password.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                    placeholder: "密码"
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    block: "",
                    onClick: handleLogin
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("登录")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (isLoggedIn.value)
      ? (_openBlock(), _createBlock(_component_proto_command_test, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})